import { render } from "./EmailCampaigns.vue?vue&type=template&id=154e9702&scoped=true"
import script from "./EmailCampaigns.vue?vue&type=script&lang=js"
export * from "./EmailCampaigns.vue?vue&type=script&lang=js"

import "./EmailCampaigns.vue?vue&type=style&index=0&id=154e9702&scoped=true&lang=scss"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154e9702"]])

export default __exports__